function SentIcon(props)
{
    return(
        <svg viewBox="0 0 24 24" className={props.class}><g id="Share-3" data-name="Share"><path d="M21.707,2.293a1,1,0,0,0-1.069-.225l-18,7a1,1,0,0,0,.145,1.909l8.379,1.861,1.862,8.379a1,1,0,0,0,.9.78L14,22a1,1,0,0,0,.932-.638l7-18A1,1,0,0,0,21.707,2.293ZM14.262,17.568,13.1,12.319l2.112-2.112a1,1,0,0,0-1.414-1.414L11.681,10.9,6.432,9.738,19.244,4.756Z"/></g></svg>
    )
}

export default SentIcon